<template>
  <div class="">
    <div class="flex justify-between items-center mb-6">
      <div>
        <h1 class="text-4xl">Commission  Accounts</h1>
        <!-- <p class="text-sm text-gray-400">Welcome to your dashboard</p> -->
      </div>

      <div class="flex">
        <router-link
          to="/commission/dissolve_commission"
          class="
            border
            px-6
            py-2
            rounded-lg
            text-sm
            mr-2
            flex
            justify-center
            items-center
            hover:bg-gray-100
          "
        >
          Dissolve commision 
        </router-link>
        <!-- <router-link
          to="/replenishment"
          class="
            border
            px-6
            py-2
            rounded-lg
            text-sm
            flex
            justify-center
            items-center
            hover:bg-gray-100
          "
        >
          Float Replenishment
        </router-link> -->
      </div>
    </div>

    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div
            class="
              shadow
              overflow-hidden
              border-b border-gray-200
              sm:rounded-lg
            "
          >
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-gray-500
                      uppercase
                      tracking-wider
                    "
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-gray-500
                      uppercase
                      tracking-wider
                    "
                  >
                    Commission Balance
                  </th>
              

                 

                  <th scope="col" class="relative px-6 py-3">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody v-if="commissions" class="bg-white divide-y divide-gray-200">
                <tr v-for="(commission, i) in commissions" :key="i">
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="flex items-center">{{commission.name}}</div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm font-medium text-gray-900">
                     GMD {{ formatPrice(commission.balance /100)}}
                      
                    </div>
                 
                  </td>
               

               
                </tr>

                <!-- More people... -->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import BranchSales from "../../components/Charts/BranchSales";

import { mapGetters } from "vuex";
import checkPermissionExist from "../../mixins/checkPermissionExist";

export default {
  middleware: "auth",
  layout: "default",
  components: {
    // BranchSales,
    // HelloWorld
  },

  mixins: [checkPermissionExist],
  computed: mapGetters({
    user: "auth/user",
  }),

  data: () => ({
    floats: null,
    commissions:[]
  }),

  created() {
      this.loadC()
    var _this = this;
    _this.loadData(1);
    // if (!this.checkPermissionExist(this.user.data, "floats-read")) {
    //   this.$router.go(-1);
    //   return false;
    // }
  },

  methods: {
    total(param) {
      return param.reduce(function (total, item) {
        return total + item.balance_allocated;
      }, 0);
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    async loadC(){

        try {
            const {data} =  await axios.get(`/commission/accounts`);
  
            console.log('my data.....', data);
            
        } catch (error) {
            console.log('error', error);
            
        }
          

    },

    async loadData(pageNo, filter) {
      // Submit the form
      if (filter) {
        // filter = filter;
        this.searching = true;
      } else {
        filter = "";
        this.searching = false;
      }

      try {
        const { data } = await axios.get(
          `/commission/accounts`
        );


        this.commissions = data;
        this.searching = false;

        // console.log("The current page is: ", this.agents.meta.current_page);

        return true;
      } catch (e) {
        console.log("Error");
        this.searching = false;
        return false;
      }
    },
  },
};
</script>
